import { http } from '@/http'
import { imgServe } from '@/imageServe'

const PATH = 'app/'

class HomeService {
  async latestRecords () {
    return http.get(PATH.concat('latest-records'))
  }

  async getDataByCollabId (id) {
    return http.get(PATH.concat('collab-data/').concat(id))
  }
  
  async getCollabs () {
    return http.get(PATH.concat('all-collabs'))
  }

  async getDataCard(id, month = null, year = null) {
    const params = {
      month: month,
      year: year
    };

    const headers = {
      __user: id
    }

    return http.get(PATH.concat('cards-statics'), { 
      params, 
      headers 
    })
  }

  async generateReportPonto (data) {
    return http.post();
  }
  
}

export default new HomeService()
export { PATH }
